import { Capacitor } from "@capacitor/core";

const getWebPlatform = (): string => {
  if (Capacitor.isNativePlatform()) {
    return "undefined";
  } else if (!window.navigator.userAgentData) {
    return navigator.platform || "undefined";
  } else {
    return window.navigator.userAgentData.platform;
  }
};

export const getPlatform = (): string => {
  if (Capacitor.isNativePlatform()) {
    return Capacitor.getPlatform();
  } else if (Capacitor.getPlatform() === "web") {
    return getWebPlatform();
  } else {
    return "undefined";
  }
};
